import React, { Component } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Snackbar from "@material-ui/core/Snackbar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {
  GetCityByProvinceId,
  GetAgents,
  DeleteAgent,
  GetAllBrands,
  GetProvinces,
  GetAgentss,
  GetAllByAdmin,
  GetAllByCity,
  GetAllByBrand,
} from "../../fetchs";
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import CircularProgress from "@material-ui/core/CircularProgress";
import TablePagination from "@material-ui/core/TablePagination";
import { ModalDetailOrder } from "../Useful/Useful";
import DeleteIcon from "@material-ui/icons/Delete";
import AlertDialog from "../Prompt/alert-dialog.component";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./setting-list.styles.css";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";

const headCells = [
  { id: "index", numeric: false, disablePadding: true, label: "ردیف" },
  {
    id: "image",
    numeric: false,
    disablePadding: true,
    label: "نام نماینده فروش",
  },
  { id: "key", numeric: false, disablePadding: true, label: "نام برند" },
  { id: "title", numeric: false, disablePadding: true, label: "نام شهر" },

  { id: "tools", numeric: false, disablePadding: true, label: "" },
];

const EnhancedTableHead = () => {
  //const { classes } = props;

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={headCell.disablePadding ? "none" : "default"}
          >
            <TableSortLabel active={false}>{headCell.label}</TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
    width: "200px",
  },
  title: {
    flex: "0 0 auto",
  },
  formControl: {
    width: "150px",
  },
  link: {
    margin: "10px",
    lineHeight: "4",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {
          <Typography variant="h6" id="tableTitle">
            لیست نماینده گان فروش
          </Typography>
        }
      </div>
      <div className={classes.spacer} />
      {/* <div className={classes.actions}>
        <Link to='/main/sellagent' className={classes.link}>
          <Button variant='contained' color='primary'>
            ساخت نماینده فروش جدید
          </Button>
        </Link>
      </div> */}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default class SettingList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      provinceId: "",
      province: [],
      rows: [],
      loading: false,
      openSnackbar: false,
      errorMessage: "",
      page: 0,
      rowsPerPage: 20,
      rowsLength: 0,
      alertDialog: false,
      deleteId: "",
      brands: [],
      brandId: null,
      cities: [],
      cityId: null,
      users: [],
      userId: null,
    };
  }

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  handleChangeProvince = (name) => (event) => {
    this.setState({ [name]: event.target.value }, () => {
      this.getCitiesByProvince();
    });
  };

  getCitiesByProvince = () => {
    GetCityByProvinceId(this.state.provinceId)
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ cities: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
  };
  componentDidMount() {
    this.getSettings();
    GetAllBrands()
      .then((response) => {
        this.setState({ loading: false });
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ brands: responseJson });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });
    GetProvinces(0, 999)
      .then((response) => {
        this.setState({ loading: false });
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ province: responseJson });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });
    GetAgentss()
      .then((response) => {
        this.setState({ loading: false });
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ users: responseJson.data });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });
  }
  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.getSettings();
    });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 }, () => {
      this.getSettings();
    });
  };

  handleDelete = () => {
    this.setState({ alertDialog: false, loading: true });
    DeleteAgent(this.state.deleteId)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status === 200)
          toast.success("نماینده فروش با موفقیت حذف شد");
        else toast.error("خطای حذف نماینده فروش");
        this.getSettings();
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handlePrepareDelete = (id) => {
    this.setState({ deleteId: id, alertDialog: true });
  };

  handleCloseDialog = () => {
    this.setState({ alertDialog: false });
  };

  getSettings = () => {
    this.setState({ loading: true });
    GetAgents(this.state.page, this.state.rowsPerPage)
      .then((response) => {
        this.setState({ loading: false });
        return response.json();
      })
      .then((responseJson) => {
        this.setState({
          rows: responseJson.data,
          rowsLength: responseJson.count,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });
  };
  handleBrandChange = (e) => {
    this.setState({ brandId: e.target.value }, () => {
      this.getProductsFromServer();
    });
  };

  handleCityChange = (e) => {
    this.setState({ cityId: e.target.value }, () => {
      this.getProductsFromServer();
    });
  };
  handleUserChange = (e) => {
    this.setState({ userId: e.target.value }, () => {
      this.getProductsFromServer();
    });
  };
  getProductsFromServer = () => {
    this.setState({ loading: true });
    if (this.state.brandId) {
      GetAllByBrand(this.state.brandId)
        .then((response) => {
          this.setState({ loading: false });
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });
          else
            this.setState({
              rows: responseJson,
              // rowsLength: responseJson.count,
            });
        })
        .catch((error) => {
          this.setState({ loading: false });
          console.error(error);
        });
    } else if (this.state.cityId) {
      GetAllByCity(this.state.cityId)
        .then((response) => {
          this.setState({ loading: false });
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });
          else
            this.setState({
              rows: responseJson,
              // rowsLength: responseJson.count,
            });
        })
        .catch((error) => {
          this.setState({ loading: false });
          console.log(error);
        });
    } else if (this.state.userId) {
      GetAllByAdmin(this.state.userId)
        .then((response) => {
          this.setState({ loading: false });
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });
          else
            this.setState({
              rows: responseJson,
              // rowsLength: responseJson.count,
            });
        })
        .catch((error) => {
          this.setState({ loading: false });
          console.log(error);
        });
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className="root">
        <Paper className="paper">
          <EnhancedTableToolbar numSelected={0} />
          <div className="tableWrapper">
            <Grid container spacing={2}>
              <Grid item sm={2}>
                <TextField
                  id="standard-select-city"
                  select
                  label="استان"
                  required
                  fullWidth
                  value={this.state.provinceId}
                  onChange={this.handleChangeProvince("provinceId")}
                  margin="normal"
                >
                  {this.state.province.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name} - {option.province}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item sm={2}>
                <TextField
                  id="standard-select-city"
                  select
                  label="شهر"
                  required
                  fullWidth
                  // className={classes.textField}
                  value={this.state.cityId}
                  onChange={this.handleCityChange}
                  // SelectProps={{
                  //   MenuProps: {
                  //     className: classes.menu,
                  //   },
                  // }}
                  margin="normal"
                >
                  {this.state.cities.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name} - {option.province}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item sm={2}>
                <TextField
                  id="brandId"
                  name="brandId"
                  select
                  label="برند"
                  required
                  fullWidth
                  value={this.state.brandId}
                  onChange={this.handleBrandChange}
                  margin="normal"
                >
                  {this.state.brands.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item sm={2}>
                <TextField
                  id="brandId"
                  name="brandId"
                  select
                  label="کاربر"
                  required
                  fullWidth
                  // className={classes.textField}
                  value={this.state.userId}
                  onChange={this.handleUserChange}
                  // SelectProps={{
                  //   MenuProps: {
                  //     className: classes.menu,
                  //   },
                  // }}
                  margin="normal"
                >
                  {this.state.users.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name} {option.family}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>

            <Table
              className="table"
              aria-labelledby="tableTitle"
              size={"medium"}
            >
              <EnhancedTableHead classes={classes} numSelected={0} />
              <TableBody>
                {this.state.rows.map((row, index) => {
                  return (
                    <TableRow hover tabIndex={-1} key={row.id}>
                      <TableCell align="center">
                        {this.state.page * this.state.rowsPerPage + index + 1}
                      </TableCell>

                      <TableCell align="center">{row.userName}</TableCell>
                      <TableCell align="center">{row.brandName}</TableCell>
                      <TableCell align="center">{row.cityName}</TableCell>
                      {/* <TableCell align='center'>
                        <ModalDetailOrder
                          buttonLabel='نمایش توضیحات'
                          title='توضیحات'
                          desc={row.desc ? row.desc : "توضیحات ثبت نشده است"}
                        ></ModalDetailOrder>
                      </TableCell> */}

                      <TableCell align="center">
                        <Link to={`/main/sellagent/${row.id}`}>
                          <EditIcon color="primary" />
                        </Link>
                        <DeleteIcon
                          className="deleteIcon"
                          onClick={() => this.handlePrepareDelete(row.id)}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
          {this.state.loading && (
            <CircularProgress size={24} className="buttonProgress" />
          )}
          <TablePagination
            rowsPerPageOptions={[20, 50, 100]}
            component="div"
            count={this.state.rowsLength}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            backIconButtonProps={{
              "aria-label": "previous page",
            }}
            nextIconButtonProps={{
              "aria-label": "next page",
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
        <AlertDialog
          open={this.state.alertDialog}
          title={`اخطار`}
          body={`آیا از حذف نماینده فروش اطمینان دارید؟`}
          handleYes={this.handleDelete}
          handleNo={this.handleCloseDialog}
        />
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          autoHideDuration={3000}
          open={this.state.openSnackbar}
          ContentProps={{
            "aria-describedby": "message-id",
            class:
              "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
          }}
          message={<span id="message-id"> {this.state.errorMessage} </span>}
          onClose={() => this.handleCloseSnackbar(false)}
        />
      </div>
    );
  }
}
